module.exports = __webpack_public_path__ + "img/1556955014.b06136b9.jpg";